import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import {
  EXPERTISE_MEDICAL_ID,
  logoSanlamBase64,
  newLogoSanlamBase64,
} from 'components/DesignationLetter/constants';
import moment from 'moment';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    lineHeight: 1.5,
  },
  image: {
    textAlign: 'left',
    width: '130px',
    height: '30px',
    padding: '0px',
  },
  newImage: {
    textAlign: 'left',
    width: '220px',
    height: '70px',
    padding: '0px',
    marginLeft: '-20px',
  },
  header: {
    fontWeight: 'bold',
  },
  underline: {
    textDecoration: 'underline',
  },
  rightAlign: {
    textAlign: 'right',
    marginBottom: 20,
  },
  section: {
    marginBottom: 20,
  },
  bodyText: {
    marginBottom: 10,
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: '#000',
    marginTop: 20,
    width: '60%',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCell: {
    flex: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000',
    padding: 4,
  },
  tableCel: {
    flex: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    padding: 4,
  },
  lastCell: {
    borderRightWidth: 0,
  },
  footer: {
    fontSize: '9px',
    marginRight: '50px',
    marginTop: '40px',
    marginBottom: '10px',
    textAlign: 'left',
  },
  footerView: {
    position: 'absolute',
    bottom: 20,
    left: 40,
    right: 40,
    textAlign: 'center',
    fontSize: 10,
    color: 'grey',
  },
  lastView: {
    marginTop: '40px',
  },
  newFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    color: '#000',
    textAlign: 'left',
  },
  newFooterLeft: {
    flex: 1,
    paddingRight: 10,
  },
  newFooterLine1: {
    fontSize: 10,
  },
  newFooterLine2: {
    fontSize: 7.5,
  },
  newFooterBold: {
    fontWeight: 'bold',
  },
  newFooterLegal: {
    fontSize: 6.5,
  },
  newFooterRight: {
    width: 100,
    paddingTop: 12,
  },
  newFooterContactRow: {
    flexDirection: 'row',
    fontSize: 7.5,
  },
  newFooterContactLabel: {
    width: 18,
    fontWeight: 'bold',
  },
  newFooterWeb: {
    fontSize: 7.5,
    marginLeft: 18,
  },
});
const dateNow = moment().format('DD/MM/YYYY');

const DesignationLetterTransaction = (props: any) => {
  const renderFooter = () => {
    if (featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)) {
      return (
        <View style={styles.newFooter}>
          <View style={styles.newFooterLeft}>
            <Text style={styles.newFooterLine1}>
              Assurance Non-Vie {'  •  '} Assurance Vie
            </Text>
            <Text style={styles.newFooterLine2}>
              <Text style={styles.newFooterBold}>SanlamAllianz Maroc</Text>
              {'  |  216, Bd Zerktouni  |  CP : 20000  |  Casablanca, Maroc'}
            </Text>
            <Text style={styles.newFooterLegal}>
              SanlamAllianz Maroc - société anonyme d’assurances et de
              réassurance au capital social de 534.187.400 de DH. Entreprise
              régie par la loi n° 17-99 portant code des assurances. RC
              Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
              355.11.249 - IF : 01084025 - ICE : 000230054000034
            </Text>
          </View>

          <View style={styles.newFooterRight}>
            <View style={styles.newFooterContactRow}>
              <Text style={styles.newFooterContactLabel}>T</Text>
              <Text>+212 522 42 06 06</Text>
            </View>
            <View style={styles.newFooterContactRow}>
              <Text style={styles.newFooterContactLabel}>F</Text>
              <Text>+212 522 20 60 81</Text>
            </View>
            <Text style={styles.newFooterWeb}>SanlamAllianz.ma</Text>
          </View>
        </View>
      );
    } else if (featureService.hasFeature(FEATURES.FUSION)) {
      return (
        <Text style={styles.footer}>
          Assurance Non-Vie | Assurance Vie | Sanlam Maroc | 216, Bd Zerktouni |
          CP: 20000 | Casablanca, Maroc Sanlam Maroc - société anonyme
          d’assurances et de réassurance au capital social de 534.187.400 de DH.
          Entreprise régie par la loi n° 17-99 portant code des assurances. RC
          Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
          355.11.249 IF : 01084025 - ICE : 000230054000034 T +212 522 42 06 06 F
          +212 522 20 60 81 sanlam.ma
        </Text>
      );
    } else {
      return (
        <Text style={styles.footer}>
          Assurance Non-Vie | Assurance Vie | Sanlam Maroc | 216, Bd Zerktouni |
          CP: 20000 | Casablanca, Maroc Sanlam Maroc - société anonyme
          d’assurances et de réassurance au capital social de 411.687.400 de DH.
          Entreprise régie par la loi n° 17-99 portant code des assurances. RC
          Casablanca : 22.341. CNSS : 167.8541 - Taxe professionnelle :
          355.11.249 IF : 01084025 - ICE : 000230054000034 T +212 522 42 06 06 F
          +212 522 20 60 81 sanlam.ma
        </Text>
      );
    }
  };
  return (
    <Document>
      <Page style={styles.page}>
        <Image
          style={
            featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)
              ? styles.newImage
              : styles.image
          }
          src={
            featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)
              ? newLogoSanlamBase64
              : logoSanlamBase64
          }
        />
        <View style={[styles.section, styles.rightAlign]}>
          <Text>Casablanca, le {dateNow} </Text>
        </View>

        <View style={[styles.section, styles.rightAlign]}>
          <Text> {props.data?.expertInfo?.ItemDescription}</Text>
          <Text> {props.data?.expertInfo?.address}</Text>
          <Text> {props.data?.expertInfo?.expertTown}</Text>
        </View>

        <View style={[styles.section]}>
          <Text style={styles.underline}></Text>
        </View>

        <View style={[styles.section]}>
          <Text style={[styles.header]}>
            Direction Automobile – Sce Transaction
          </Text>
          <Text style={[styles.header]}>Objet : Assistance à Expertise</Text>
          <Text style={[styles.header]}>
            Référence Dossier : {props.data.claimNumber}
          </Text>
          <Text style={[styles.header]}>
            Date Survenance : {moment(props.data.lossDate).format('DD/MM/YYYY')}
          </Text>
          <Text style={[styles.header]}>
            N° Mission : {props.data.reference}
          </Text>
        </View>
        <View style={[styles.section]}>
          <Text>
            {Number(props.data.type) === EXPERTISE_MEDICAL_ID
              ? 'Docteur,'
              : 'Cher(e) Expert,'}
          </Text>
        </View>

        <View style={styles.bodyText}>
          <Text>
            Nous vous prions de bien vouloir examiner le nommée,
            {props.data.victim} victime d'un accident de circulation survenu en
            date du, {moment(props.data.lossDate).format('DD/MM/YYYY')}
          </Text>
        </View>

        <View style={styles.bodyText}>
          <Text>
            Les dispositions du Dahir portant loi n° 1 84 177 du 2 octobre 1984
            (Bulletin Officiel N° 3757) relatif à l'indemnisation des victimes
            d'accidents causés par des véhicules terrestres à moteur, étant
            applicables à ce sinistre, il y a lieu de vous conformer aux
            prescriptions du Décret n° 2-84-744 du 14 janvier 1985 (B.O. N°
            3768) relatif au Barème Fonctionnel des incapacités qui constitue le
            texte d'application du dit Dahir portant loi.
          </Text>
        </View>

        <View style={styles.bodyText}>
          <Text>
            Veuillez agréer,
            {Number(props.data.type) === EXPERTISE_MEDICAL_ID
              ? 'Docteur,'
              : 'Monsieur'}
            , l’expression de nos salutations distinguées.
          </Text>
        </View>
        <View style={styles.lastView}>
          <View style={styles.bodyText}>
            <Text>{props.data.createdBy?.toUpperCase()}</Text>
          </View>
          <View style={styles.bodyText}>
            <Text>Coordinateur Transaction</Text>
          </View>
          <View style={styles.bodyText}>
            <Text>216, Bd Zerktouni, Casablanca CP 20000 – MAROC</Text>
          </View>
        </View>

        <View fixed style={styles.footerView}>
          {renderFooter()}
        </View>
      </Page>
    </Document>
  );
};

export default DesignationLetterTransaction;
